import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HighlightOutlinedSvg from "@ant-design/icons-svg/es/asn/HighlightOutlined";
import AntdIcon from "../components/AntdIcon";
var HighlightOutlined = function HighlightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HighlightOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HighlightOutlined.displayName = 'HighlightOutlined';
}
export default /*#__PURE__*/React.forwardRef(HighlightOutlined);